import NotFoundImg from 'assets/images/not-found.png';

import { FC } from 'react';
// i18next
import { useTranslation } from 'react-i18next';

const NotFoundPage:FC = () => {
  const { t } = useTranslation();

  return (
    <div className="h-full p-4 flex flex-col justify-center items-center gap-3">
      <img src={NotFoundImg} alt="Page Not Found" className="w-3/4" />
      <h3 className="text-3xl font-semibold">{t('pages.notFound.title')}</h3>
      <p className="text-xs text-center">{t('pages.notFound.content')}</p>
    </div>
  );
}

export default NotFoundPage;
